import { hexToCSSFilter } from 'hex-to-css-filter';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { getFontURL } from 'src/utils/getFontUrl';

export const ShortAnswerSurveyStyles = () => {
  const templateWidth = useSelector(
    (state: any) => state.template.templateWidth
  );
  const templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );

  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const titleFontURL = getFontURL(fontFamily?.title);
  const title_0201FontURL = getFontURL(fontFamily?.title_0201);
  const sub_title_0201FontURL = getFontURL(fontFamily?.sub_title_0201);
  const button_0201FontURL = getFontURL(btnFontFamily?.button_0201);
  const left_buttonFontURL = getFontURL(btnFontFamily?.left_button);
  const right_buttonFontURL = getFontURL(btnFontFamily?.right_button);
  const option_buttonFontURL = getFontURL(btnFontFamily?.option_button);
  const text_areaFontURL = getFontURL(btnFontFamily?.text_area);
  const selected_left_buttonFontURL = getFontURL(
    btnFontFamily?.selected_left_button
  );

  const MIN_STYLE = `
    .center_wrapper .logo {
      margin-bottom: 0;
    }
    .survey_wrapper {
      margin-bottom: 8px;
      gap: 8px;
    }
    .bottom {
      bottom: 16px;
    }
  `;

  const CLOSE_FILTER = bgColor?.close?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close?.[currentIndex])
    : { filter: '' };
  const CLOSE_FILTER_0201 = bgColor?.close_0201?.[currentIndex]
    ? hexToCSSFilter(bgColor?.close_0201?.[currentIndex])
    : { filter: '' };

  const backImageUrl =
    'https://image.inappmessage.com/sample/arrow-sm-left.png';

  return `
    @font-face {
      font-family: 'titleFont';
      src: url('${titleFontURL}');
    }
    @font-face {
      font-family: 'title_0201Font';
      src: url('${title_0201FontURL}');
    }
    @font-face {
      font-family: 'sub_title_0201Font';
      src: url('${sub_title_0201FontURL}');
    }
    @font-face {
      font-family: 'button_0201Font';
      src: url('${button_0201FontURL}');
    }
    @font-face {
      font-family: 'left_buttonFont';
      src: url('${left_buttonFontURL}');
    }
    @font-face {
      font-family: 'right_buttonFont';
      src: url('${right_buttonFontURL}');
    }
    @font-face {
      font-family: 'option_buttonFont';
      src: url('${option_buttonFontURL}');
    }
    @font-face {
      font-family: 'text_areaFont';
      src: url('${text_areaFontURL}');
    }
    @font-face {
      font-family: 'selected_left_buttonFont';
      src: url('${selected_left_buttonFontURL}');
    }

    .root_view {
      width: 100%;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      background-repeat: no-repeat;
      background-size: cover !important;
      background-position: center !important;
      background: #fff;

      ${
        bg?.background === 'image'
          ? `background-image: url(${bgImage?.background?.[currentIndex]})`
          : `background: ${bgColor?.background?.[currentIndex]}`
      };

      .center_horizon {
        width: 80%;
        max-width: 300px;

        position: absolute;
        left: 50%;
        transform: translate(-50%, 0%);
      }

      .top_wrapper {
        width: 100%;
        top: 6%;
        display: flex;
        justify-content: space-between;
      }
      .back_btn,
      .close_btn {
        width: 1.5rem;
        height: 1.5rem;
        
        background-image: url("https://image.inappmessage.com/sample/black-close.png");
        background-repeat: no-repeat;
        background-size: 1.5rem;
        background-position: center;
        filter: ${CLOSE_FILTER.filter};
  
        font-size: 0;
        border: none;
        background-color: transparent;
      }
      .back_btn {
        background-image: url(${backImageUrl});
      }

      .template {
        width: 100%;
        max-width: 375px;
        height: 100%;
        max-height: 812px;
        margin: auto;
        position: relative;
      }

      .center_wrapper {
        width: 80%;
        max-width: 300px;
        display: flex;
        flex-direction: column;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .center_wrapper .title {
        width: 100%;
        height: 64px;
        margin-bottom: 8px;

        display: flex;
        justify-content: center;
        align-items: center;

        text-align: ${textAlign?.title};
        color: ${color?.title};
        font-size: ${fontSize?.title}rem;
        font-weight: ${fontWeight?.title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title
          )
            ? `'${fontFamily?.title}'`
            : 'titleFont'
        };
      }
      .center_wrapper .title_inner {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .center_wrapper .logo {
        width: 100%;
        height: 96px;
        margin-bottom: 24px;

        display: flex;
        justify-content: center;
        align-items: center;
      }

      .logo button {
        width: 100%;
        height: 100%;

        background-image: url(${bgImage?.logo?.[currentIndex]});
        background-repeat: no-repeat !important;
        background-size: contain !important;
        background-position: center !important;

        font-size: 0;
        border: none;
        background-color: transparent;
      }

      .survey_wrapper {
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      .survey {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .survey_radius {
        width: 24px;
        height: 24px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 24px;
        border: 1px solid ${btnColor?.radio_button};
        background: rgba(${btnBgColorR?.radio_button},${
    btnBgColorG?.radio_button
  },${btnBgColorB?.radio_button},${btnBgColorA?.radio_button});
      }
      .survey_action {
        width: 16px;
        height: 16px;

        border-radius: 16px;
        background: ${btnColor?.radio_button};
      }
      .survey_wrapper p {
        height: 32px;

        display: flex;
        align-items: center;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        color: ${btnColor?.option_button};
        font-size: ${btnFontSize?.option_button}rem;
        font-weight: ${btnFontWeight?.option_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.option_button
          )
            ? `'${btnFontFamily?.option_button}'`
            : 'option_buttonFont'
        };
        };
      }
      .survey_wrapper .hr {
        border-radius: 16px;
        border: 1px solid #373737;
      }

      .textarea {
        height: 72px;
        padding: 16px;
        border: none;
        resize: none;
        border-radius: 8px;

        color: ${btnColor?.text_area};
        font-size: ${btnFontSize?.text_area}rem;
        font-weight: ${btnFontWeight?.text_area};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.text_area
          )
            ? `'${btnFontFamily?.text_area}'`
            : 'text_areaFont'
        };
        background-color: rgba(${btnBgColorR?.text_area},${
    btnBgColorG?.text_area
  },${btnBgColorB?.text_area},${btnBgColorA?.text_area});
      }

      .bottom {
        width: 100%;
        height: 48px;
        bottom: 32px;

        display: flex;
        gap: 16px;
      }
      .bottom button {
        width: 100%;
        height: 48px;
        border: 0;
      }
      .left_button {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        color: ${btnColor?.left_button};
        font-size: ${btnFontSize?.left_button}rem;
        font-weight: ${btnFontWeight?.left_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.left_button
          )
            ? `'${btnFontFamily?.left_button}'`
            : 'left_buttonFont'
        };

        border-radius: ${radius?.left_button}px;
        background-color: rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  },${btnBgColorB?.left_button},${btnBgColorA?.left_button});
      }
      .left_button.action {
        color: ${btnColor?.selected_left_button};
        font-size: ${btnFontSize?.selected_left_button}rem;
        font-weight: ${btnFontWeight?.selected_left_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.selected_left_button
          )
            ? `'${btnFontFamily?.selected_left_button}'`
            : 'selected_left_buttonFont'
        };

        border-radius: ${radius?.selected_left_button}px;
        background-color: rgba(${btnBgColorR?.selected_left_button},${
    btnBgColorG?.selected_left_button
  },${btnBgColorB?.selected_left_button},${btnBgColorA?.selected_left_button});
      }
      .right_button {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        color: ${btnColor?.right_button};
        font-size: ${btnFontSize?.right_button}rem;
        font-weight: ${btnFontWeight?.right_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.right_button
          )
            ? `'${btnFontFamily?.right_button}'`
            : 'right_buttonFont'
        };

        border-radius: ${radius?.right_button}px;
        background-color: rgba(${btnBgColorR?.right_button},${
    btnBgColorG?.right_button
  },${btnBgColorB?.right_button},${btnBgColorA?.right_button});
      }

      ${templateHeight <= 710 ? `${MIN_STYLE}` : ''}

      @media screen and (max-height: 720px) {
        ${MIN_STYLE}
      }
    }

    .root_view_0201 {
      background: #fff;
      ${
        bg?.background_0201 === 'image'
          ? `background-image: url(${bgImage?.background_0201?.[currentIndex]})`
          : `background: ${bgColor?.background_0201?.[currentIndex]}`
      };

      .close_btn {
        filter: ${CLOSE_FILTER_0201.filter};
      }

      .logo button {
        background-image: url(${bgImage?.logo_0201?.[currentIndex]});
      }

      .center_wrapper .title {
        text-align: ${textAlign?.title_0201};
        color: ${color?.title_0201};
        font-size: ${fontSize?.title_0201}rem;
        font-weight: ${fontWeight?.title_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title_0201
          )
            ? `'${fontFamily?.title_0201}'`
            : 'title_0201Font'
        };
      }
      .center_wrapper .sub_title {
        width: 100%;
        height: 64px;
        margin-bottom: 8px;

        display: flex;
        justify-content: center;
        align-items: center;

        text-align: ${textAlign?.sub_title_0201};
        color: ${color?.sub_title_0201};
        font-size: ${fontSize?.sub_title_0201}rem;
        font-weight: ${fontWeight?.sub_title_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title_0201
          )
            ? `'${fontFamily?.sub_title_0201}'`
            : 'sub_title_0201Font'
        };
      }
      .center_wrapper .sub_title_inner {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }

      .button {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        color: ${btnColor?.button_0201};
        font-size: ${btnFontSize?.button_0201}rem;
        font-weight: ${btnFontWeight?.button_0201};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button_0201
          )
            ? `'${btnFontFamily?.button_0201}'`
            : 'button_0201Font'
        };

        border-radius: ${radius?.button_0201}px;
        background-color: rgba(${btnBgColorR?.button_0201},${
    btnBgColorG?.button_0201
  },${btnBgColorB?.button_0201},${btnBgColorA?.button_0201});
      }
    }
  `;
};
